import {OrderedMap} from "immutable";
import Meta from "../_data/models/Meta";
import {Action} from "redux-actions";
import {
    clearConversationsAction,
    clearMessagesAction,
    receiveConversationsAction,
    receiveMessagesAction,
    requestConversationsAction,
    requestMessagesAction,
    sendMessageAction,
    composeMessageAction,
    requestFailed,
    requestStarted,
    requestSucceeded
} from "./actions";
import {combineReducers} from "redux";
import {plainToClass} from "class-transformer";

//CONVERSATIONS
export const conversations = combineReducers({
    ids: conversationIds,
    loading: conversationLoading,
    meta: conversationMeta
});

function conversationIds(state: number[] = [], action: Action<ConversationAction>) {
    switch (action.type) {
        case receiveConversationsAction.toString():
            return [...state, ...action.payload.conversationIds];             
        case clearConversationsAction.toString():
            return [];
    }
    return state;
}

function conversationLoading(state: boolean = false, action: Action<ConversationAction>) {
    switch (action.type) {
        case requestConversationsAction.toString():
            return true;
        case receiveConversationsAction.toString():
            return false;
    }
    return state;
}

function conversationMeta(state: boolean = null, action: Action<ConversationAction>) {
    switch (action.type) {
        case receiveConversationsAction.toString():
            return plainToClass(Meta, action.payload.meta);
        case clearConversationsAction.toString():
            return null;
    }
    return state;
}

//interfaces
interface ConversationAction {
    conversationIds: number[];
    meta: Meta;
}


//MESSAGES
export const messages = combineReducers({
    ids: messageIds,
    loading: messageLoading,
    meta: messageMeta,
    composedMessage
});

function messageIds(state: number[] = [], action: Action<MessageAction>) {
    switch (action.type) {
        case receiveMessagesAction.toString():
        case sendMessageAction.toString():        
            return [...state, ...action.payload.messageIds];   
        case clearMessagesAction.toString():
            return [];
    }   
    return state;
}

function messageLoading(state: boolean = false, action: Action<MessageAction>) {
    switch (action.type) {    
        case requestStarted.toString():
            return true;  
        case requestSucceeded.toString():
            return false;
    }
    return state;
}

function messageMeta(state: boolean = null, action: Action<MessageAction>) {
    switch (action.type) {
        case receiveMessagesAction.toString():
            if(action.payload.meta)
                return plainToClass(Meta, action.payload.meta);
            else
                return state;
        case clearMessagesAction.toString():
            return null;
    }
    return state;
}

function errors(state: string[] = [], action: Action<ApiRequestAction>) {
    switch (action.type){
        case requestStarted.toString():
            return [];
        case requestSucceeded.toString():
            return [];
        case requestFailed.toString():
            return action.payload.requestErrors
    }

    return state;
}

function composedMessage(state: string = "", action: Action<MessageAction>) {
    if(action.type == composeMessageAction.toString()) {                        
        return action.payload;        
    }

    return state;
}

//interfaces
interface MessageAction {
    conversationId: number;
    messageIds: number[];
    meta: Meta;    
}



// WEBPACK FOOTER //
// ./app/client/message/reducers.ts